import React, { useState, useEffect } from 'react';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import Brand from '../../../../assets/images/logo.png';
import { ref, update, onChildAdded, onChildChanged } from "firebase/database";
import { validateAndSortNumbers } from "../../../../utils/functions";
import firebaseDb from '../../../../utils/firebase.util';
import { TIME_ZONE } from '../../../../config/variables';
import moment from 'moment-timezone';
import { useRef } from 'react';

function StudentSideBarCtrl(props){

    const user = props.user;
    const [chatUnread, setChatUnread] = useState(0);
    const [supportChatUnread, setSupportChatUnread] = useState(0);

    var chatUnreadRef = useRef(0)
    var supportChatUnreadRef = useRef(0)
    const chatInitializeRef = useRef(false)
    var usersList = {}
    var keysArr = []

    let underscorePattern = /[_]/i
    let filteredRole = user.role
    if (underscorePattern.test(filteredRole)) {

        let splitStringToArr = filteredRole.split('_')
        filteredRole = ''
        for (let arrElm of splitStringToArr) {
            filteredRole = filteredRole + ' ' + arrElm
        }
    }

    useEffect(() => {

        if (chatInitializeRef.current === false) {
            initiateChats()
        }

    }, [chatUnread]);

    const navigate = useNavigate()
    const initiateChats = async () => {

        if (Object.keys(user).length > 0) {

            const chatListRef = ref(firebaseDb, `chats`);

            chatInitializeRef.current = true

            onChildAdded(chatListRef, (data) => {

                var otherUser = null

                let value = data.val()

                let recentCount = chatUnreadRef.current
                let suportRecentCount = supportChatUnreadRef.current
                for (let itemKey in value) {

                    let usrItem = value[itemKey]

                    // if(usrItem?.to_user_unique_id === user?.unique_id){
                    //     if(usrItem?.is_seen == 0){
                    //         recentCount = recentCount + 1 
                    //     }
                    // }

                    // if(usrItem.role != 'super_admin' && usrItem.role != 'sub_super_admin') {

                    otherUser = usrItem
                    let keyName = `${usrItem.unique_id}`

                    if (!usersList.hasOwnProperty(keyName)) {
                        usersList[keyName] = []
                    }
                    
                    if (usrItem['to_user_unique_id'] == user?.unique_id && usrItem['is_seen'] === 0 && !keysArr.includes(itemKey)) {
                        if(usrItem['type'] === 'support' ){
                            suportRecentCount = suportRecentCount + 1
                        }else{
                            recentCount = recentCount + 1
                        }
                        
                    }

                    if (!keysArr.includes(itemKey)) {
                        keysArr.push(itemKey)
                        usersList[keyName].push(usrItem)
                    }

                    // }

                }

                /* Update status to Online, Offline */

                for (let itmKey in value) {

                    let usrItm = value[itmKey]

                    if (otherUser) {
                        if (usrItm.role == user.role && usrItm.user_id == user.id) {
                            const updates = {};
                            updates[`chats/user_${validateAndSortNumbers(otherUser.unique_id, user.unique_id)}`] = {
                                ...value[itmKey],
                                status: 'online',
                                timestamp: moment().tz(TIME_ZONE).format('XX'),
                                timestampFormatted: moment().tz(TIME_ZONE).format('YYYY-MM-DD HH:mm:ss')
                            };

                            update(ref(firebaseDb), updates);
                        }
                    }
                }
                chatUnreadRef.current = recentCount
                supportChatUnreadRef.current = suportRecentCount
                setChatUnread(chatUnreadRef.current)
                setSupportChatUnread(supportChatUnreadRef.current)
            });

            onChildChanged(chatListRef, (data) => {

                let value = data.val()

                let recentCount = chatUnreadRef.current
                let suportRecentCount = supportChatUnreadRef.current


                for (let key in value) {
                    let usrItem = value[key]

                    // if(usrItem.role != 'super_admin' && usrItem.role != 'sub_super_admin') {

                    let keyName = `${usrItem.unique_id}`
                    if (!usersList.hasOwnProperty(keyName)) {
                        usersList[keyName] = []
                    }

                    if (usrItem['to_user_unique_id'] == user?.unique_id && usrItem['is_seen'] === 0 && !keysArr.includes(key)) {
                        if(usrItem['type'] === 'support' ){
                            suportRecentCount = suportRecentCount + 1
                        }else{
                            recentCount = recentCount + 1
                        }
                    }

                    if (!keysArr.includes(key)) {
                        keysArr.push(key)
                        usersList[keyName].push(usrItem)
                        /* if( usrItem['is_seen'] === 0 ) {

                            chatUnreadRef.current = chatUnreadRef.current + 1
 
                        }else {
 
                            chatUnreadRef.current = Math.abs(chatUnreadRef.current - 1)
                        } */
                    }

                    // }
                }
                chatUnreadRef.current = recentCount
                supportChatUnreadRef.current = suportRecentCount
                setChatUnread(chatUnreadRef.current)
                setSupportChatUnread(supportChatUnreadRef.current)

            });
        }
    }

    const [ alertModalShow, setAlertModalShow ] = useState(false)

    const openLibrary = (e) => {
        e.preventDefault()

        if(user.is_content_allowed) {
            navigate('/student/library')
        }else {
            setAlertModalShow(true)
        }
    }

    return(
        <>
            <NavLink className='logged_user'>
                {/* <img className='logged_user_img' src={user.picture_path} />
                <p>{user.full_name}</p>
                <span className='logged_user_typ'>{user.role}</span> */}
                
                <img width={100} src={Brand} />
            </NavLink>
            <Button className="toggle" onClick={props.toggleSideBar}>
                <span className="line-toggle"></span>
                <span className="line-toggle"></span>
                <span className="line-toggle"></span>
            </Button>
            <div className='sidebar_menu'>
                <NavLink to="dashboard">
                    <div className='d-flex align-items-center'>
                        <span className="menu_icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" fillRule="evenodd" clipRule="evenodd" d="M7 3C9.20914 3 11 4.79086 11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3ZM7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5ZM17 3C19.2091 3 21 4.79086 21 7C21 9.20914 19.2091 11 17 11C14.7909 11 13 9.20914 13 7C13 4.79086 14.7909 3 17 3ZM17 5C15.8954 5 15 5.89543 15 7C15 8.10457 15.8954 9 17 9C18.1046 9 19 8.10457 19 7C19 5.89543 18.1046 5 17 5ZM11 17C11 14.7909 9.20914 13 7 13C4.79086 13 3 14.7909 3 17C3 19.2091 4.79086 21 7 21C9.20914 21 11 19.2091 11 17ZM5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17ZM17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13ZM17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15Z" fill=""/>
                            </svg>
                        </span>
                        <span className="">Dashboard</span>
                    </div>
                </NavLink>
                <NavLink to="library" onClick={(event) => openLibrary(event)} >
                    <div className='d-flex align-items-center'>
                        <span className="menu_icon">
                            <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" d="M12.5656 0C12.8874 0 13.1349 0.2625 13.1349 0.575V4.6C13.1349 6.8875 15.0037 8.7625 17.2686 8.775C18.2092 8.775 18.9517 8.7875 19.521 8.7875L19.7319 8.78657C20.1123 8.78368 20.6246 8.775 21.0681 8.775C21.3775 8.775 21.625 9.025 21.625 9.3375V19.3875C21.625 22.4875 19.1374 25 16.0681 25H6.21658C2.99876 25 0.375 22.3625 0.375 19.1125V5.6375C0.375 2.5375 2.875 0 5.95668 0H12.5656ZM13.8899 16.125H7.15718C6.64975 16.125 6.22896 16.5375 6.22896 17.05C6.22896 17.5625 6.64975 17.9875 7.15718 17.9875H13.8899C14.3973 17.9875 14.8181 17.5625 14.8181 17.05C14.8181 16.5375 14.3973 16.125 13.8899 16.125ZM11.3403 9.875H7.15718C6.64975 9.875 6.22896 10.3 6.22896 10.8125C6.22896 11.325 6.64975 11.7375 7.15718 11.7375H11.3403C11.8478 11.7375 12.2686 11.325 12.2686 10.8125C12.2686 10.3 11.8478 9.875 11.3403 9.875ZM14.9384 1.1325C14.9384 0.59375 15.5856 0.32625 15.9557 0.715C17.2936 2.12 19.6314 4.57625 20.9384 5.94875C21.2998 6.3275 21.0349 6.95625 20.5139 6.9575C19.4965 6.96125 18.2973 6.9575 17.4347 6.94875C16.0658 6.94875 14.9384 5.81 14.9384 4.4275V1.1325Z" fill=""/>
                            </svg>
                        </span>
                        <span className="">Library</span>
                    </div>
                </NavLink>

                <NavLink to="support">
                    <div className='d-flex align-items-center'>
                        <span className="menu_icon">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_stroke path_fill" fillRule="evenodd" clipRule="evenodd" d="M7.87138 16.3125C7.88452 14.5891 9.28996 13.2013 11.0134 13.21C12.7369 13.2188 14.1283 14.6207 14.1239 16.3442C14.1196 18.0677 12.7212 19.4626 10.9977 19.4626C10.1651 19.4606 9.36743 19.1273 8.78088 18.5363C8.19433 17.9453 7.8671 17.1452 7.87138 16.3125Z" fill="" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                <path className="path_stroke" d="M18.5017 13.1862C18.3751 13.1855 18.2606 13.2612 18.2117 13.378C18.1627 13.4948 18.1891 13.6295 18.2784 13.7193C18.3676 13.809 18.5022 13.8361 18.6193 13.7878C18.7363 13.7395 18.8126 13.6254 18.8126 13.4988C18.8133 13.416 18.7808 13.3363 18.7224 13.2776C18.664 13.2189 18.5845 13.186 18.5017 13.1862" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                <path className="path_stroke" d="M22.3921 13.1862C22.2655 13.1855 22.151 13.2612 22.102 13.378C22.0531 13.4948 22.0795 13.6295 22.1687 13.7193C22.258 13.809 22.3926 13.8361 22.5096 13.7878C22.6267 13.7395 22.703 13.6254 22.703 13.4988C22.7037 13.416 22.6712 13.3363 22.6128 13.2776C22.5543 13.2189 22.4749 13.186 22.3921 13.1862" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                <path className="path_stroke path_fill" fillRule="evenodd" clipRule="evenodd" d="M4.74512 26.4731V25.6915C4.75017 23.967 6.14691 22.5702 7.87142 22.5652H14.124C15.8485 22.5702 17.2453 23.967 17.2503 25.6915V26.4731C17.2491 26.9042 16.8999 27.2534 16.4688 27.2546H5.52669C5.09556 27.2534 4.74638 26.9042 4.74512 26.4731Z" fill="" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                <path className="path_stroke" d="M11.344 8.49677C13.5403 5.35308 17.5288 4.00754 21.1807 5.17834C24.8325 6.34914 27.2951 9.76298 27.2541 13.5977C27.2131 17.4324 24.6781 20.7928 21.002 21.8852" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </span>
                        <span className="">Support</span>
                    </div>
                    {supportChatUnread > 0 &&
                        <span className='badge'>{supportChatUnread}</span>
                    } 
                </NavLink>
                
                <NavLink to="chat">
                    <div className='d-flex align-items-center'>
                        <span className="menu_icon">
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" fillRule="evenodd" clipRule="evenodd" d="M10.0282 0C4.50537 0 0.0282136 4.47715 0.0282136 10C0.0194714 12.3091 0.819006 14.5485 2.28821 16.33L0.288214 18.33C0.00446904 18.6176 -0.0783831 19.0476 0.0782136 19.42C0.248082 19.788 0.62327 20.017 1.02821 20H10.0282C15.5511 20 20.0282 15.5228 20.0282 10C20.0282 4.47715 15.5511 8.22968e-08 10.0282 0ZM10.0282 18H3.43821L4.36821 17.07C4.75594 16.68 4.75594 16.05 4.36821 15.66C1.6681 12.9629 1.2491 8.73406 3.36744 5.55952C5.48578 2.38498 9.55154 1.1488 13.0784 2.60691C16.6053 4.06503 18.6112 7.81138 17.8693 11.555C17.1275 15.2986 13.8446 17.997 10.0282 18Z" fill=""/>
                            </svg>
                        </span>
                        <span className="">Chat</span>
                    </div>
                    {chatUnread > 0 &&
                        <span className='badge'>{chatUnread}</span>
                    } 
                </NavLink>

                <NavLink to="logout">
                    <div className='d-flex align-items-center'>
                        <span className="menu_icon">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" fillRule="evenodd" clipRule="evenodd" d="M13.5303 7.96975C13.2374 7.67686 12.7626 7.67686 12.4697 7.96975C12.1768 8.26264 12.1768 8.73752 12.4697 9.03041L15.1893 11.7501L3 11.7501C2.58579 11.7501 2.25 12.0859 2.25 12.5001C2.25 12.9143 2.58579 13.2501 3 13.2501L15.1893 13.2501L12.4697 15.9698C12.1768 16.2626 12.1768 16.7375 12.4697 17.0304C12.7626 17.3233 13.2374 17.3233 13.5303 17.0304L17.5303 13.0304C17.8232 12.7375 17.8232 12.2626 17.5303 11.9698L13.5303 7.96975ZM16.2001 3.25C17.0525 3.25 17.6468 3.25058 18.1094 3.28838C18.5633 3.32547 18.824 3.3946 19.0216 3.49523C19.4449 3.71095 19.7891 4.05516 20.0048 4.47852C20.1055 4.67604 20.1746 4.9368 20.2117 5.39068C20.2495 5.85331 20.2501 6.44755 20.2501 7.3L20.2501 17.7C20.2501 18.5525 20.2495 19.1467 20.2117 19.6093C20.1746 20.0632 20.1055 20.324 20.0049 20.5215C19.7891 20.9448 19.4449 21.289 19.0216 21.5048C18.824 21.6054 18.5633 21.6745 18.1094 21.7116C17.6468 21.7494 17.0525 21.75 16.2001 21.75L11.8001 21.75C10.9476 21.75 10.3534 21.7494 9.89077 21.7116C9.43689 21.6745 9.17612 21.6054 8.97861 21.5048C8.55524 21.289 8.21104 20.9448 7.99532 20.5215C7.89468 20.324 7.82555 20.0632 7.78847 19.6093C7.75067 19.1467 7.75009 18.5525 7.75009 17.7L7.75009 16.5C7.75009 16.0858 7.4143 15.75 7.00009 15.75C6.58587 15.75 6.25009 16.0858 6.25009 16.5L6.25009 17.7L6.25009 17.7321L6.25009 17.7321C6.25008 18.545 6.25007 19.2006 6.29345 19.7315C6.33811 20.2781 6.43247 20.7582 6.65881 21.2025C7.01834 21.9081 7.59201 22.4817 8.29762 22.8413C8.74184 23.0676 9.22198 23.162 9.76862 23.2066C10.2995 23.25 10.9551 23.25 11.768 23.25L11.8001 23.25L16.2001 23.25L16.2322 23.25C17.045 23.25 17.7006 23.25 18.2316 23.2066C18.7782 23.162 19.2583 23.0676 19.7025 22.8413C20.4082 22.4817 20.9818 21.9081 21.3414 21.2025C21.5677 20.7582 21.6621 20.2781 21.7067 19.7315C21.7501 19.2006 21.7501 18.5449 21.7501 17.7321L21.7501 17.7L21.7501 7.3L21.7501 7.26788C21.7501 6.45505 21.7501 5.79944 21.7067 5.26853C21.6621 4.72189 21.5677 4.24175 21.3414 3.79754C20.9818 3.09193 20.4082 2.51825 19.7025 2.15872C19.2583 1.93239 18.7782 1.83803 18.2316 1.79336C17.7006 1.74999 17.045 1.74999 16.2322 1.75L16.2001 1.75L11.8001 1.75L11.768 1.75C10.9551 1.74999 10.2995 1.74999 9.76862 1.79336C9.22198 1.83803 8.74184 1.93239 8.29762 2.15873C7.59201 2.51825 7.01834 3.09193 6.65881 3.79754C6.43247 4.24175 6.33811 4.7219 6.29345 5.26853C6.25007 5.79944 6.25008 6.45506 6.25009 7.2679L6.25009 7.3L6.25009 8.5C6.25009 8.91421 6.58587 9.25 7.00008 9.25C7.4143 9.25 7.75009 8.91421 7.75009 8.5L7.75009 7.3C7.75009 6.44755 7.75067 5.85331 7.78847 5.39068C7.82555 4.93681 7.89468 4.67604 7.99532 4.47852C8.21104 4.05516 8.55524 3.71095 8.97861 3.49524C9.17612 3.3946 9.43689 3.32547 9.89076 3.28838C10.3534 3.25058 10.9476 3.25 11.8001 3.25L16.2001 3.25Z" fill=""/>
                            </svg>
                        </span>
                        <span className="">Logout</span>
                    </div>
                </NavLink>

                <Modal className="approve-modal" show={alertModalShow} onHide={() => setAlertModalShow(false)} backdrop="static" keyboard={false} centered>
                    <Modal.Header className='justify-content-center'>
                    </Modal.Header>
                    <Modal.Body className='text-center'>
                        <h4>You do not have access to this feature. Contact your administration for further information.</h4>
                    </Modal.Body>
                    <Modal.Footer className='justify-content-center'>
                        <div className="d-flex gap-3">
                            <Button variant="primary" onClick={() => setAlertModalShow(false)} >Ok</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
                
            </div>

        </>
    )
}

export default StudentSideBarCtrl;